import { Link, useNavigate } from "react-router-dom";
import "../styles/NotFound.css";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="notfound-root">

      {/* Animated background blobs */}
      <div className="notfound-blob blob-1" />
      <div className="notfound-blob blob-2" />
      <div className="notfound-blob blob-3" />

      <div className="notfound-content">

        {/* Big 404 */}
        <div className="notfound-code">
          <span className="digit">4</span>
          <span className="digit zero">0</span>
          <span className="digit">4</span>
        </div>

        {/* Divider line */}
        <div className="notfound-divider" />

        {/* Message */}
        <h1 className="notfound-title">Page Not Found</h1>
        <p className="notfound-desc">
          The page you're looking for doesn't exist or has been moved.
          <br />
          Let's get you back on track.
        </p>

        {/* Actions */}
        <div className="notfound-actions">
          <button
            className="btn-primary"
            onClick={() => navigate("/")}
          >
            ← Back to Home
          </button>
          <button
            className="btn-secondary"
            onClick={() => navigate(-1)}
          >
            Go Back
          </button>
        </div>

        {/* Help links */}
        <div className="notfound-links">
          <span>Looking for something?</span>
          <Link to="/service">Services</Link>
          <Link to="/quote">Quote</Link>
          <Link to="/events">Webinars</Link>
          <Link to="/query">Contact</Link>
        </div>

      </div>
    </div>
  );
}